module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marketing-content",
    class: {
      'marketing-content--loaded': _vm.story && !_vm.story.hidden && _vm.display
    }
  }, [_c('div', {
    staticClass: "marketing-content__bg"
  }), _vm._v(" "), (_vm.story) ? _c('div', {
    staticClass: "marketing-content__wrap"
  }, [(_vm.story.title) ? _c('h3', {
    staticClass: "marketing-content__title"
  }, [_vm._v("\n      " + _vm._s(_vm.story.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.story.image && _vm.story.image.filename) ? _c('img', {
    staticClass: "marketing-content__picture",
    attrs: {
      "width": "500",
      "height": "347",
      "alt": "",
      "src": ((_vm.story.image.filename) + "/m/fit-in/1000x694/filters:format(webm):quality(90)")
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "marketing-content__text"
  }, [(_vm.story.firstParagraph) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.story.firstParagraph) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('ul', [(_vm.story.bullet1) ? _c('li', [_vm._v("\n          " + _vm._s(_vm.story.bullet1) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.story.bullet2) ? _c('li', [_vm._v("\n          " + _vm._s(_vm.story.bullet2) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.story.bullet3) ? _c('li', [_vm._v("\n          " + _vm._s(_vm.story.bullet3) + "\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.story.secondParagraph) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.story.secondParagraph) + "\n      ")]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e143b26","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/MarketingContent/MarketingContent.vue
// module id = 609
// module chunks = 1